import { Link, Stack, Text } from "@chakra-ui/react";
import { SimpleList } from "@/components/list";

const LinkComponent = ({ href, label }: { href: string; label: string }) => {
  return (
    <Link
      color="primary.200"
      fontSize={"1.2rem"}
      fontWeight={500}
      href={href}
      target="_blank"
      textDecor={"underline"}
      textDecorationColor={"#F9AF18"}
      textDecorationThickness={"1px"}
      textUnderlineOffset={"4px"}
    >
      {label}
    </Link>
  );
};

export const FAQS = [
  {
    title: "What is the difference between colocation and cloud hosting?",
    content: (
      <SimpleList
        points={[
          "Colocation: You own and maintain the hardware, but it is housed in a third-party data center.",
          "Cloud Hosting: You utilize virtual resources provided and managed by a cloud service provider.",
        ]}
      />
    ),
  },
  {
    title: "Can I upgrade my colocation services as my business grows?",
    content:
      "Yes, OneMind offers scalable colocation solutions, allowing you to expand your infrastructure seamlessly as your needs evolve.",
  },
  {
    title: "How does OneMind ensure the security of my equipment?",
    content:
      "Our data centers are equipped with 24/7 surveillance, biometric access controls, and adhere to strict security protocols to protect your assets.",
  },
  {
    title: "What support services are available for colocation clients?",
    content:
      "OneMind provides 24/7/365 priority support, ensuring assistance is always available when you need it.",
  },
  {
    title: "Are there any long-term contracts required for colocation services?",
    content:
      "No, OneMind offers flexible terms with no long-term contracts, providing you with the freedom to adjust services as needed.",
  },
  {
    title: "What types of colocation services are available?",
    content: (
      <Stack gap={1}>
        <SimpleList
          points={[
            "Retail Colocation: Renting space within a data center, such as a rack or a portion of a rack, suitable for businesses with smaller space requirements.",
            "Wholesale Colocation: Leasing an entire data center area, ideal for organizations needing extensive space and resources.",
          ]}
        />
        <LinkComponent
          href="https://www.wallstreetmojo.com/"
          label="wallstreetmojo.com"
        />
      </Stack>
    ),
  },
  {
    title:
      "How do colocation services support disaster recovery and business continuity?",
    content: (
      <Stack gap={1}>
        <Text>
          Colocation facilities offer redundant power sources, backup generators, and
          advanced cooling systems to ensure uninterrupted service during outages, which
          is critical for disaster recovery and business continuity.
        </Text>
        <LinkComponent href="https://encoradvisors.com/" label="encoradvisors.com" />
      </Stack>
    ),
  },
  {
    title: "What is the typical pricing structure for colocation services?",
    content: (
      <Stack gap={1}>
        <Text>
          Pricing is usually based on the physical space occupied (e.g., per rack unit),
          power consumption, and additional services like network connectivity and
          support. Costs can vary depending on location and provider.
        </Text>
        <LinkComponent href="https://dgtlinfra.com/" label="dgtlinfra.com" />
      </Stack>
    ),
  },
  {
    title: "Can colocation services be combined with cloud solutions?",
    content:
      "Yes, many businesses adopt a hybrid approach, integrating colocation with cloud services to balance control, scalability, and cost-effectiveness.",
  },
  {
    title: "What security measures are in place at colocation facilities?",
    content:
      "Colocation centers implement advanced security protocols, including 24/7 surveillance, biometric access controls, and strict access policies to protect clients' equipment and data.",
  },
  {
    title: "How does colocation differ from managed hosting?",
    content: (
      <SimpleList
        points={[
          "Colocation: Clients own and maintain their hardware, housing it in a third-party data center.",
          "Managed Hosting: The service provider owns the hardware and is responsible for its maintenance, while clients utilize the resources on a subscription basis.",
        ]}
      />
    ),
  },
  {
    title: "What factors should be considered when choosing a colocation provider?",
    content: (
      <Stack>
        <Text>Key considerations include: </Text>
        <SimpleList
          points={[
            "Location: Proximity to your business operations and clients.",
            "Reliability: Uptime guarantees and redundancy features.",
            "Scalability: Ability to accommodate future growth.",
            "Security: Robust physical and network security measures.",
            "Compliance: Adherence to industry-specific regulations and standards.",
          ]}
        />
      </Stack>
    ),
  },
];
